/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnregisteredRouteImport } from './routes/unregistered'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvoiceCheckoutRouteImport } from './routes/invoice-checkout'
import { Route as AuthCallbackRouteImport } from './routes/authCallback'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutPaymentRouteImport } from './routes/_layout/payment'
import { Route as LayoutHistoryRouteImport } from './routes/_layout/history'

const UnregisteredRoute = UnregisteredRouteImport.update({
  id: '/unregistered',
  path: '/unregistered',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoiceCheckoutRoute = InvoiceCheckoutRouteImport.update({
  id: '/invoice-checkout',
  path: '/invoice-checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/authCallback',
  path: '/authCallback',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPaymentRoute = LayoutPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHistoryRoute = LayoutHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/invoice-checkout': typeof InvoiceCheckoutRoute
  '/login': typeof LoginRoute
  '/unregistered': typeof UnregisteredRoute
  '/history': typeof LayoutHistoryRoute
  '/payment': typeof LayoutPaymentRoute
  '/settings': typeof LayoutSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/invoice-checkout': typeof InvoiceCheckoutRoute
  '/login': typeof LoginRoute
  '/unregistered': typeof UnregisteredRoute
  '/history': typeof LayoutHistoryRoute
  '/payment': typeof LayoutPaymentRoute
  '/settings': typeof LayoutSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/authCallback': typeof AuthCallbackRoute
  '/invoice-checkout': typeof InvoiceCheckoutRoute
  '/login': typeof LoginRoute
  '/unregistered': typeof UnregisteredRoute
  '/_layout/history': typeof LayoutHistoryRoute
  '/_layout/payment': typeof LayoutPaymentRoute
  '/_layout/settings': typeof LayoutSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authCallback'
    | '/invoice-checkout'
    | '/login'
    | '/unregistered'
    | '/history'
    | '/payment'
    | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authCallback'
    | '/invoice-checkout'
    | '/login'
    | '/unregistered'
    | '/history'
    | '/payment'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/authCallback'
    | '/invoice-checkout'
    | '/login'
    | '/unregistered'
    | '/_layout/history'
    | '/_layout/payment'
    | '/_layout/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  InvoiceCheckoutRoute: typeof InvoiceCheckoutRoute
  LoginRoute: typeof LoginRoute
  UnregisteredRoute: typeof UnregisteredRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unregistered': {
      id: '/unregistered'
      path: '/unregistered'
      fullPath: '/unregistered'
      preLoaderRoute: typeof UnregisteredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice-checkout': {
      id: '/invoice-checkout'
      path: '/invoice-checkout'
      fullPath: '/invoice-checkout'
      preLoaderRoute: typeof InvoiceCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authCallback': {
      id: '/authCallback'
      path: '/authCallback'
      fullPath: '/authCallback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/payment': {
      id: '/_layout/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof LayoutPaymentRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/history': {
      id: '/_layout/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof LayoutHistoryRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutHistoryRoute: typeof LayoutHistoryRoute
  LayoutPaymentRoute: typeof LayoutPaymentRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutHistoryRoute: LayoutHistoryRoute,
  LayoutPaymentRoute: LayoutPaymentRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  InvoiceCheckoutRoute: InvoiceCheckoutRoute,
  LoginRoute: LoginRoute,
  UnregisteredRoute: UnregisteredRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
